export default __webpack_public_path__ + "static/media/spratt2.17d3177e.jpg";